type FillingColor = {
    id?: number;
    isDefault?: boolean;
};

type FillingWithColors = {
    id?: string | number;
    selectedColor?: Partial<Record<'outer' | 'inner', FillingColor>> | null;
    selectedColorSecond?: Partial<Record<'outer' | 'inner', FillingColor>> | null;
};

type SashWithFillings = {
    glazing?: FillingWithColors | null;
    panelInner?: FillingWithColors | null;
    intSashes?: SashWithFillings[];
};

const copyColor = <T>(color: T): T => JSON.parse(JSON.stringify(color));

/**
 * Repairs saved configurations with an explicit color on the door sash and a stale,
 * default color on its internal sash. The drawing uses the internal sash, while the
 * color controls use the main sash.
 */
export function restoreExplicitFillingColorsInInternalSashes(sashes: SashWithFillings[]) {
    const restoreColors = (
        source: FillingWithColors | null | undefined,
        target: FillingWithColors | null | undefined
    ) => {
        if (!source || !target || String(source.id) !== String(target.id)) {
            return;
        }

        (['selectedColor', 'selectedColorSecond'] as const).forEach((colorField) => {
            (['outer', 'inner'] as const).forEach((side) => {
                const sourceColor = source[colorField]?.[side];
                const targetColor = target[colorField]?.[side];
                if (
                    sourceColor?.id &&
                    sourceColor.isDefault === false &&
                    (!targetColor?.id || targetColor.isDefault !== false)
                ) {
                    target[colorField] = target[colorField] || {};
                    target[colorField][side] = copyColor(sourceColor);
                }
            });
        });
    };

    sashes.forEach((sash) => {
        sash.intSashes?.forEach((intSash) => {
            restoreColors(sash.glazing, intSash.glazing);
            restoreColors(sash.panelInner, intSash.panelInner);
        });
    });
}
